/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import change pic
import StockMid from '../views/stock-mid/ListStockMid.vue';
import DuplicateMid from '../views/mid/ListDuplicateMid.vue';
import DetailDuplicateMid from '../views/mid/ListDetailDuplicateMid.vue';

import { setBreadcrumb } from './index';

const midRoute = {
  path: '/mid',
  name: 'Mid',
  meta: {
    title: 'BNI QRIS - MID',
    appBarTitle: 'MID',
  },
  component: Parent,
  children: [
    {
      path: '/stock-mid/list',
      meta: {
        title: 'BNI QRIS - Stock MID',
        appBarTitle: 'Stock MID',
        breadcrumbs: () => [
          setBreadcrumb('MID', '/mid', true),
          setBreadcrumb('list Stock MID', '/stock-mid/list'),
        ],
      },
      component: StockMid,
      name: 'StockMid',
    },
    {
      path: '/duplicate-mid/list',
      meta: {
        title: 'BNI QRIS - Duplicate MID',
        appBarTitle: 'Duplicate MID',
        breadcrumbs: () => [
          setBreadcrumb('MID', '/mid', true),
          setBreadcrumb('list Duplicate MID', '/duplicate-mid/list'),
        ],
      },
      component: DuplicateMid,
      name: 'DuplicateMid',
    },
    {
      path: '/duplicate-mid/list/detail/:id',
      meta: {
        title: 'BNI QRIS - Detail Duplicate MID',
        appBarTitle: 'Detail Duplicate MID',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('MID', '/mid', true),
            setBreadcrumb('list Duplicate MID', '/duplicate-mid/list'),
            setBreadcrumb(
              `list Detail Duplicate MID - ${id}`,
              `/duplicate-mid/list/${id}`,
              true
            ),
          ];
        },
      },
      component: DetailDuplicateMid,
      name: 'DetailDuplicateMid',
    },
  ],
};
export default midRoute;
